module.exports = __webpack_public_path__ + "img/visacard.2b615d51.png";